export default {
  namespaced: true,
  state: {
    initialized: false,
    kegList: [],
  },
  getters: {
    
  },
  mutations: {
    setInitialized(state, data) {
      state.initialized = data;
    },
    setKegListData(state, data) {
      state.kegList.splice(0);
      for (const d of data) {
        state.kegList.push(d);
      }
    },
    updateKeg(state, data) {
      for (let i=0;i<state.kegList.length;i++) {
        if (state.kegList[i].serial === data.serial) {
          state.kegList.splice(i, 1, data);
          return;
        }
      }
      state.kegList.push(data);
    },
    removeKeg(state, serial) {
      for (let i=0;i<state.kegList.length;i++) {
        if (state.kegList[i].serial === serial) {
          state.kegList.splice(i, 1);
          return;
        }
      }
    },
  },
  actions: {
    async initKegList({ commit, dispatch, state }) {
      if (state.initialized) {
        return;
      }
      const res = await dispatch('api/getKegListPromise', null, { root: true });
      commit('setKegListData', res);
      commit('setInitialized', true);
    },
    async refreshKegList({ commit, dispatch }) {
      const res = await dispatch('api/getKegListPromise', null, { root: true });
      // console.log(res)
      commit('setKegListData', res);
      commit('setInitialized', true);
    },
    async createKegs({ commit, dispatch }, kegs) {
      for (const keg of kegs) {
        const res = await dispatch('api/postCreateKegPromise', keg, { root: true });
        commit('updateKeg', res);
      }
    },
    async deleteKegs({ commit, dispatch }, kegSerials) {
      for (const kegSerial of kegSerials) {
        await dispatch('api/postDeleteKegPromise', kegSerial, { root: true });
        commit('removeKeg', kegSerial);
      }
    },
    async kegRent({commit, dispatch}, {kegSerial, clientSerial}) {
      const res = await dispatch('api/postKegRentPromise', {kegSerial, clientSerial}, { root: true });
      commit('updateKeg', res);
    },
    async kegStock({commit, dispatch}, {kegSerial}) {
      const res = await dispatch('api/postKegStockPromise', {kegSerial}, { root: true });
      commit('updateKeg', res);
    },
    async kegMissing({commit, dispatch}, {kegSerial}) {
      const res = await dispatch('api/postKegMissingPromise', {kegSerial}, { root: true });
      commit('updateKeg', res);
    },
    async kegRetired({commit, dispatch}, {kegSerial}) {
      const res = await dispatch('api/postKegRetiredPromise', {kegSerial}, { root: true });
      commit('updateKeg', res);
    },
    async kegUpdateWashed({commit, dispatch}, {kegSerial, washed}) {
      const res = await dispatch('api/postKegEditWashedPromise', {kegSerial, washed}, { root: true });
      commit('updateKeg', res);
    },
    async kegUpdateFilled({commit, dispatch}, {kegSerial, filled}) {
      const res = await dispatch('api/postKegEditFilledPromise', {kegSerial, filled}, { root: true });
      commit('updateKeg', res);
    },
    async kegWashed({commit, dispatch}, {kegSerial}) {
      const res = await dispatch('api/postKegWashedPromise', {kegSerial}, { root: true });
      commit('updateKeg', res);
    },
    async kegFilled({commit, dispatch}, {kegSerial}) {
      const res = await dispatch('api/postKegFilledPromise', {kegSerial}, { root: true });
      commit('updateKeg', res);
    },
  }

}
